import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import qs from 'qs';
import { CreateNewsPropositionsRequest, NewsFiltersProps, NewsListItem, NewsView } from '../interfaces';
import { PaginatedResponse, PaginationState, TagView } from 'src/types';

export const newsUrl = '/News';
export const newsPropositionsApiUrl = '/NewsPropositions';

const ApiUrls = {
  newsUrl,
  newsPropositionsApiUrl
};

const GetNews = (data: Partial<NewsFiltersProps> & PaginationState): Promise<PaginatedResponse<NewsListItem>> =>
  nzApiAxios
    .get(newsUrl, {
      params: data,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params)
      }
    })
    .then((response) => response.data);

const GetSingleNews = (slug: string | undefined): Promise<NewsView> =>
  nzApiAxios.get(`${newsUrl}/${slug}`).then((response) => response.data);

const GetNewsTags = (): Promise<TagView[]> => nzApiAxios.get(`${newsUrl}/tags`).then((response) => response.data);

const PostNewsPropositionRequest = (data: CreateNewsPropositionsRequest) =>
  nzApiAxios.post(newsPropositionsApiUrl, data);

const API = {
  GetNews: GetNews,
  GetSingleNews: GetSingleNews,
  GetTags: GetNewsTags,
  proposeNews: PostNewsPropositionRequest
};

export { ApiUrls };
export default API;
